import { useRouter } from 'vue-router'

export const useRouterRemoveQueryParam = () => {
  const router = useRouter()

  async function removeQueryParams(paramsToRemove: string[]) {
    const searchParams = new URLSearchParams(window.location.search.substring(1))
    for (const param of paramsToRemove) {
      searchParams.delete(param)
    }
    const query: Record<string, string> = {}
    searchParams.forEach((key, value) => {
      query[value] = key
    })
    await router.replace({ query })
  }

  return { removeQueryParams }
}
